import React,{useState,useEffect} from 'react';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Ajax from './Ajax';
import {Inc,Play,Bottle,EventParam} from "./Inc";
import {Styles} from './Styles';
import {Tools} from './Tools';
import Loading from './Loading';
import FourMeters from './FourMeters';
import Parameter from './Parameter';

interface Props {
    play:Play,
    param:EventParam,
    close(play:Play):void,
}

let selectedIndex = 0;

const EventBottles = (props:Props)=> {
    const classes = Styles.base();
    //const [selected,setSelected] = useState(false);
    //const [finished,setFinished] = useState(false);
    const [states,setStates] = useState({
        newPlay: Inc.defaultPlay(),
        selected: false,
        finished: false,
        isLoading: false,
    })
    const drink = (e: React.MouseEvent<HTMLElement>) =>{
        if( e.currentTarget.dataset.index ){
            selectedIndex = parseInt(e.currentTarget.dataset.index);
        } else {
            selectedIndex = 0;
        }
        setStates({...states,isLoading:true});
        Ajax.send("event/send",{play_id:props.play.id,selected:selectedIndex},(res:any)=>{
            if( res.ok ){
                setStates({...states,newPlay:res.play,isLoading:false,selected:true});
            }
        })
    }
    const close = ()=>{
        props.close(states.newPlay);
    }
    const finish = ()=>{
        setStates({...states,finished:true});
    }

    useEffect( ()=>{
        selectedIndex = 0;
    },[]);

    if( states.selected ){
        return (
            <div id="event_bottles">
                <div className={classes.room}>
                {selectedIndex===0 ? (
                    <span>ボトルには手をつけずに冷蔵庫を閉じると、のどの渇きが痛みのように感じられた</span>
                ):(
                    <React.Fragment>
                    <span>
                        {props.param.bottles[selectedIndex-1].color}のボトルを飲んだ<br/>
                    </span>
                    {props.param.bottles[selectedIndex-1].id<7 &&
                    <span>
                        胃の底に粉末状の何かが沈殿していく予感に身を震わせた
                    </span>
                    }
                    </React.Fragment>
                )}
                </div>
                <div className={classes.meters}>
                    <FourMeters stWater={props.play.water} stMagenta={props.play.magenta} stCyan={props.play.cyan} stYellow={props.play.yellow} enWater={states.newPlay.water} enMagenta={states.newPlay.magenta} enCyan={states.newPlay.cyan} enYellow={states.newPlay.yellow} finish={finish}/>
                </div>
                {states.finished &&
                <div className={classes.modalBottom}>
                    <FormControl fullWidth={true} className={classes.formControl}>
                        <Button variant="outlined" color="primary" onClick={close} style={{width:"100%"}}>{Tools.voice()}</Button>
                    </FormControl>
                </div>
                }
            </div>
        );    
    }

    return (
        <div id="event_bottles">
            <div className={classes.room}>
            ベッドと冷蔵庫がある部屋だ<br/>
            冷蔵庫には水のボトルが並んでいる<br/>
            {props.param.selected===0 &&
                <div>先に{Tools.lover(props.play,props.param)}が物色したようだが、ボトルはいずれも手つかずだ</div>
            }
            {props.param.selected>0 &&
                <div>{props.param.bottles[props.param.selected-1].color}のボトルは{Tools.lover(props.play,props.param)}が飲んでしまったようだ</div>
            }
            </div>
            <div className={classes.modalBottom}>
                <FormControl fullWidth={true} className={classes.formControl}>
                    {props.param.bottles.map( (bottle:Bottle,index:number)=>{
                        const key = "bottle" + index;
                        return (
                            <Button key={key} variant="outlined" color="primary" style={{marginBottom:"0.2em"}} onClick={drink} data-index={index+1} disabled={bottle.used}>{bottle.color}を飲む</Button>
                        )
                    })}
                    <Button variant="outlined" color="primary" onClick={drink} data-index={0} style={{marginBottom:"0.2em"}}>飲まない</Button>
                </FormControl>
                <Parameter play={props.play}/>
            </div>
            <Loading isLoading={states.isLoading}/>
        </div>
    );
}

export default EventBottles;
